import { useEffect, useState } from 'react'
import { useLocation } from 'react-router'

import { useOutsideClick } from 'app/common/presentation'
import { useUser } from 'app/user/application'

import styles from './Profile.module.scss'
import ProfileButton from './ProfileButton'
import WorkspaceMenu from './WorkspaceMenu'

const Profile = () => {
  const location = useLocation()
  const { workspace, user } = useUser()

  const [open, setOpen] = useState(false)

  useEffect(() => setOpen(false), [location])

  const ref = useOutsideClick<HTMLDivElement>(() => setOpen(false))

  return (
    workspace &&
    user && (
      <div className={styles.profile} ref={ref}>
        <ProfileButton workspace={workspace} onClick={() => setOpen(!open)} />
        {open && <WorkspaceMenu workspace={workspace} user={user} />}
      </div>
    )
  )
}

export default Profile
